import React from "react";
import LoginForm from "../components/LoginForm";

type Props = { onLogin: (token: string) => void };

export default function LoginPage({ onLogin }: Props) {
  return (
    <div className="min-h-screen bg-blue-50">
      {/* Logo and Form Container */}
      <div className="flex flex-col items-center justify-center min-h-screen p-8">
        <img src="/fov-logo.webp" alt="Field of Vision" className="w-64 h-auto mb-4" />
        <h1 className="text-3xl font-bold text-slate-800 mb-8">Stadium Dashboard</h1>
        <LoginForm onLogin={onLogin} />
      </div>
    </div>
  );
}
